import {
  WorkspaceEmptyStateFrame,
  WorkspaceEmptyStateInset,
  WorkspaceEmptyStateMessage,
} from "./WorkspaceEmptyStateFrame";

export function NoActiveThreadState() {
  return (
    <WorkspaceEmptyStateInset>
      <NoActiveThreadStateView />
    </WorkspaceEmptyStateInset>
  );
}

/** Reserved for the case it names: no thread is selected. A selected thread the client
 * cannot read belongs in `ThreadUnavailableState` when its Environment is unreachable,
 * and in `ThreadUnreadableState` when the Environment is fine and the thread is not. */
export function NoActiveThreadStateView() {
  return (
    <WorkspaceEmptyStateFrame heading="No active thread">
      <WorkspaceEmptyStateMessage
        title="Pick a thread to continue"
        detail="Select an existing thread or create a new one to get started."
      />
    </WorkspaceEmptyStateFrame>
  );
}
